/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Automation_Source_LabelInputs */

const en_automation_source_label = /** @type {(inputs: Automation_Source_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.source === "case-lifecycle") return /** @type {LocalizedString} */ (`Case lifecycle`);
	if (i?.source === "task-assignment") return /** @type {LocalizedString} */ (`Task assignment`);
	if (i?.source === "task-notifications") return /** @type {LocalizedString} */ (`Task notifications`);
	if (i?.source === "task-emails") return /** @type {LocalizedString} */ (`Task emails`);
	if (i?.source === "task-analysis") return /** @type {LocalizedString} */ (`Task AI analysis`);
	return /** @type {LocalizedString} */ (`${i?.source}`)
	
};

const pt_br2_automation_source_label = /** @type {(inputs: Automation_Source_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.source === "case-lifecycle") return /** @type {LocalizedString} */ (`Ciclo do caso`);
	if (i?.source === "task-assignment") return /** @type {LocalizedString} */ (`Atribuição de tarefas`);
	if (i?.source === "task-notifications") return /** @type {LocalizedString} */ (`Notificações de tarefas`);
	if (i?.source === "task-emails") return /** @type {LocalizedString} */ (`E-mails de tarefas`);
	if (i?.source === "task-analysis") return /** @type {LocalizedString} */ (`Análise de tarefas por IA`);
	return /** @type {LocalizedString} */ (`${i?.source}`)
	
};

/**
* | source | output |
* | --- | --- |
* | "case-lifecycle" | "Case lifecycle" |
* | "task-assignment" | "Task assignment" |
* | "task-notifications" | "Task notifications" |
* | "task-emails" | "Task emails" |
* | "task-analysis" | "Task AI analysis" |
* | * | "{source}" |
*
* @param {Automation_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_source_label = /** @type {((inputs: Automation_Source_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Source_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_source_label(inputs)
	return pt_br2_automation_source_label(inputs)
});